"use client";
import React from "react";
import Image from "next/image";

export function EmptyState() {
  return (
    <div className="w-full h-96 flex justify-center items-center">
      <div className="flex flex-col items-center gap-4">
        <Image
          src="/images/empty_cart.svg"
          width={200}
          height={200}
          alt="search"
        />
        <p className="text-center text-gray-400">Your cart is empty</p>
      </div>
    </div>
  );
}
